import { useState } from "react"
import { Box, Typography } from "@mui/material"
import { Bound } from "lib/@components/binding/Bound"
import { Repeat } from "lib/@components/repeat"
import { If } from "lib/@components/if"
import { Else } from "lib/@components/else"
import { NoResults } from "lib/@components/no-results/no-results"
import LoadingScreen from "minimals-template/components/LoadingScreen"
import { IS_LOADING } from "lib/graphql/return-is-loading-on-each-request"
import { withInitialValue } from "lib/graphql/with-initial-value"
import { DebouncedTextField } from "lib/@components/debounced-text-field"
import { setFromEvent } from "lib/setFromEvent"
import { getCopClientAssignments } from "./controller/get-cop-client-assignments.controller"
import { CopClientRow } from "./cop-client-row"

export function CopClientAssignmentTab({ codeOfPracticeId }) {
    const [search, setSearch] = useState("")
    const data = getCopClientAssignments.useResults(
        { codeOfPracticeId, searchTerm: search || undefined },
        withInitialValue(IS_LOADING)
    )

    if (data === IS_LOADING) return <LoadingScreen />

    const clients = data?.clients ?? []

    return (
        <Box sx={{ py: 1 }}>
            <DebouncedTextField
                value={search}
                onChange={setFromEvent(setSearch)}
                placeholder="Search clients..."
                size="small"
                fullWidth
                sx={{ mb: 1 }}
            />
            <Bound codeOfPracticeId={codeOfPracticeId}>
                <If value={clients.length > 0}>
                    <Repeat list={clients} item={<CopClientRow />} keyFn={keyFn} pass="client" />
                    <Else>
                        <NoResults message="No clients found." />
                    </Else>
                </If>
            </Bound>
            <If value={data?.total > clients.length}>
                <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: "block" }}>
                    Showing {clients.length} of {data.total} clients
                </Typography>
            </If>
        </Box>
    )
}

function keyFn(client) {
    return client._id
}
